import { Button } from "@workspace/web-ui/components/button";
import { Separator } from "@workspace/web-ui/components/separator";
import { PenLine, Plus } from "lucide-react";
import { Allergy } from "../types";
import { Modal } from "~/features/dashboard/components/modal";
import { AllergyForm } from "./forms/allergy-form";
import { useUpdateAllergyModal } from "../store/allergy-modal";
import { useState } from "react";

const severityColors: Record<string, string> = {
  Severe: "bg-[#E12121]",
  Moderate: "bg-[#FFAB1F]",
  Mild: "bg-[#019939]",
};
interface AllergiesCardProps {
  items: Allergy[];
  onButtonClick?: () => void;
}

export default function AllergiesCard({ items, onButtonClick }: AllergiesCardProps) {
  const [selectedAllergy, setSelectedAllergy] = useState<Allergy | null>(null);
  const { isOpen: isAllergyModalOpen, open: openAllergyModal, close: closeAllergyModal } = useUpdateAllergyModal()

  return (
    <div className="border rounded-xl mt-0 shadow-sm bg-white w-full text-center mb-4 ">
      <header className="flex items-center justify-between p-5">
        <h3 className="text-lg font-medium text-[#1A202C]">Allergies</h3>
        {onButtonClick && (
          <Button 
            variant="outline"
            className="px-4 bg-primary text-white py-1 rounded-lg"
            onClick={onButtonClick}
          >
            <Plus size={16} />
            Add
          </Button>
        )}
      </header>
      <Separator />
      <div className="space-y-4 p-5">
        <ul className="space-y-4">
          {items.map((allergy, index) => (
            <li key={index} className="flex justify-between py-1 items-center">
              <div className="flex items-center gap-2">
                <span className={`size-3 rounded-full ${severityColors[allergy.severity]}`} />
                <span className="text-sm">{allergy.name}</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-500">{allergy.severity}</span>
                <Button onClick={() => { setSelectedAllergy(allergy); openAllergyModal() }} variant="ghost" size="sm" className="gap-1 border rounded-lg text-sm">
                  <PenLine size={10} className="text-[#7F8493] text-xs" />
                </Button>
              </div>
            </li>
          ))}
        </ul>
      </div>

      {selectedAllergy && (
        <Modal isOpen={isAllergyModalOpen} onClose={closeAllergyModal} title={"Update Allergies"}>
          <AllergyForm allergy={selectedAllergy} onClose={closeAllergyModal} />
        </Modal>
      )}
    </div>
  );
}
